import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  account: null,
  websites: null,
  isAuthenticated: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { setUserData } = userSlice.actions;

export default userSlice.reducer;
